import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IInitialState, RootState } from '../../../../reduxService';
import { IProjectBaseResponse } from '../../../api/IApiResponse';
/* import * as BeMaccaferriCalculationHelper from '../../api/calculation/BeMaccaferriCalculationHelper'; */
/* import { validateProjectBeforeRun } from '../../../utils/utils'; */
/* import { IProjectMacro2 } from './projectSlice'; */
import { warning } from '../../../../components/Alert/Alert';
import i18n from '../../../localization';
import { unit } from '../../../enum/project';
import { EConversionSIToImperial, convertTo } from '../../../conversion';
import { roundToTwo } from '../../../utils/utils';
import { IMacro2ProjectOutputData } from '../../../api/IApiResponse';
import BeMaccaferriStoreProvider from '../../../api/store/BeMaccaferriStoreProvider';

export interface IProjectMacro2Validation {
    startValidation: boolean;
    crest: boolean;
    crestErrors?: boolean;
    mesh: boolean;
    meshErrors?: boolean;
    rockSlope: boolean;
    rockSlopeErrors?: boolean;
    safetyCoefficients: boolean;
    safetyCoefficientsErrors?: boolean;
    siteEnvironmentalLevel: boolean;
    siteEnvironmentalLevelErrors?: boolean;
}

export interface IProjectMacro2Results {
    outputData?: IMacro2ProjectOutputData;
    validation?: IProjectMacro2Validation;
}

const initialState: IInitialState<IProjectMacro2Results> = {
    initialState: true,
};

export const resultsSlice = createSlice({
    name: 'resultsMacro2',
    initialState,
    reducers: {
        cleanResults: state => {
            state.initialState = true;
            state.data = undefined;
        },
        setOutputData: (state, action: PayloadAction<IMacro2ProjectOutputData>) => {
            state.initialState = false;
            state.data = { ...state.data, outputData: action.payload };
        },
        updateValidation: (state, action: PayloadAction<IProjectMacro2Validation>) => {
            state.initialState = false;
            state.data = { ...state.data, validation: action.payload };
        }
    },
    /*extraReducers(builder) {
        builder
            .addCase(fetchProjectResults.pending, state => {
                state.data = undefined;
                state.pending = true;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchProjectResults.fulfilled, (state, action) => {
                state.pending = false;
                state.error = undefined;
                state.initialState = false;
            })
            .addCase(fetchProjectResults.rejected, (state, action) => {
                state.data = undefined;
                state.pending = false;
                state.error = {
                    status: (action.payload as any).status,
                    data: (action.payload as any).data,
                };
                state.initialState = false;
            });
    },*/
});

/*export const fetchProjectResults = createAsyncThunk('api/Calculation/GetResultsMacra1', async (_undefined, { rejectWithValue, getState }) => {
    const state: RootState = getState() as RootState;
    const projectInfo = state.projectInfo;
    const showDischargeAlert = state.Macro2.results.showDischargeAlert;
    let isImperial = projectInfo?.data?.unit == unit.Imperial;

    try {
        if (state.Macro2.project.data!) {
            if (showDischargeAlert)
                warning(
                    i18n.t('hydraulic_data_manual_discharge_max_value_warning', {
                        max_value: isImperial
                            ? roundToTwo(convertTo(results.data.generalResult.general.discharge, EConversionSIToImperial.m3s_to_ft3s))
                            : roundToTwo(results.data.generalResult.general.discharge),
                    }),
                );
            return results.data;
        }
    } catch (error: any) {
        if (showDischargeAlert) warning(i18n.t('hydraulic_data_manual_discharge_max_value_warning'));
        return rejectWithValue(error.response);
    }
});*/

export const { cleanResults, setOutputData, updateValidation } = resultsSlice.actions;

export default resultsSlice.reducer;
